import { useAuth0, withAuthenticationRequired, type WithAuthenticationRequiredOptions } from '@auth0/auth0-react';
import { type ComponentType, type FC } from 'react';

import Loading from './Loading.js';
import { useCheckPermissions } from '../auth/index.js';

type ProtectedRouteProps = {
  component: ComponentType;
  options?: WithAuthenticationRequiredOptions;
  allowedPermission: boolean;
};

const ProtectedRoute: FC<ProtectedRouteProps> = ({ component, allowedPermission, options }) => {
  const { isAuthenticated } = useAuth0();
  const { isLoading } = useCheckPermissions();

  const Component = withAuthenticationRequired(component, {
    returnTo: '/',
    onRedirecting: () => <Loading />,
    ...options, // Overwrite default options
  });
  if (isLoading) {
    return <Loading />;
  }
  if (isAuthenticated && !allowedPermission) {
    return <p>Sorry, you don't have permission to view this.</p>;
  }

  return <Component />;
};

export default ProtectedRoute;
